import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import { oidcConfig } from './auth/config';
import { DevAuthProvider } from './auth/devAuth';
import './index.css';
import App from './App';

const isDev = import.meta.env.VITE_AUTH_MODE === 'dev';

const Auth = isDev
  ? ({ children }: { children: React.ReactNode }) => <DevAuthProvider>{children}</DevAuthProvider>
  : ({ children }: { children: React.ReactNode }) => (
      <AuthProvider {...oidcConfig}>{children}</AuthProvider>
    );

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Auth>
      <App />
    </Auth>
  </React.StrictMode>,
);